import { render, staticRenderFns } from "./sign-in-sjtu.vue?vue&type=template&id=4fbdd101"
import script from "./sign-in-sjtu.vue?vue&type=script&lang=js"
export * from "./sign-in-sjtu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports